import React, { useEffect, useState } from 'react';
import './App.css';


function App() {
  const [activeLocationFilter, setActiveLocationFilter] = useState('filter-lo-all');
  const [activeDepartmentFilter, setActiveDepartmentFilter] = useState('filter-dp-all');
  const [axiosData, setAxiosData] = useState([]);


  console.log(activeLocationFilter)
  const handleLocationFilterClick = (filter) => {
    setActiveLocationFilter(filter);
  };

  const handleDepartmentFilterClick = (filter) => {
    setActiveDepartmentFilter(filter);
  };

  const [searchbox, setSearchbox] = useState('');

  const [vacancyCount, setVacancyCount] = useState(6);


  const handleSearch = (text) => {
    console.log("Search active.")
  }

  const fetchData = async () => {
    // https://vertom.gtmstaging.com/wp-json/wp/v2/posts?categories=7
    const response = await fetch('/wp-json/wp/v2/posts?categories=6');
    const data = await response.json();
    setAxiosData(data);
  };




  let filteredData = axiosData.filter(vacancy => {


    if (activeLocationFilter !== 'filter-lo-all') {
      if (vacancy.acf.location === "The Netherlands" || vacancy.acf.location === "United Kingdom") {
        if (vacancy.acf.location.split(" ")[1].toUpperCase() !== activeLocationFilter.split('-')[2].toUpperCase()) {
          return false;
        }
      } else {
        if (vacancy.acf.location.toUpperCase() !== activeLocationFilter.split('-')[2].toUpperCase()) {
          return false;
        }
      }
    }

    if (activeDepartmentFilter !== 'filter-dp-all') {
      if (vacancy.acf.type.toUpperCase() !== activeDepartmentFilter.split('-')[2].toUpperCase()) {
        return false;
      }
    }

    if (searchbox !== '') {
      if (vacancy.title.rendered.toUpperCase().indexOf(searchbox.toUpperCase()) === -1) {
        return false;
      }
    }

    return true;
  });

  useEffect(() => {
    fetchData();
  }, [activeLocationFilter, activeDepartmentFilter]);


  let handleLoadMore = () => {

    setVacancyCount(vacancyCount + 3);
  };
  const sendHeightToParent = () => {
    const iframe = window.frameElement; // Get reference to the iframe element
    const contentDocument = iframe.contentDocument; // Access the content document

    if (contentDocument) {
      // Use the content document's body or another element to calculate height
      const contentHeight = contentDocument.body.scrollHeight;

      // Send the height to the parent
      window.parent.postMessage(
        { type: "resizeIframe", height: contentHeight },
        "*"
      );
    }
  };

  // useEffect(() => {
  //   sendHeightToParent();
  // }, []);

  // useEffect(() => {
  //   sendHeightToParent();
  // }, []);

  return (
    <div className="vacancies">

      <div className='search-and-filters'>
        <div className='page-hero__search'>
          <h2>Search for vacancy</h2>
          <input onChange={(e) => setSearchbox(e.target.value)} type='text' placeholder='Search vacancies...' value={searchbox} />
        </div>
        <div className='filters'>
          <div className="filters-location">
            <strong style={{ color: "#169555" }}>Location</strong>
            <span
              className={`location-filter ${activeLocationFilter === 'filter-lo-all' ? 'location-active-filter' : ''}`}
              onClick={() => handleLocationFilterClick('filter-lo-all')}
            >
              All
            </span>
            <span
              className={`location-filter ${activeLocationFilter === 'filter-lo-rhoon' ? 'location-active-filter' : ''}`}
              onClick={() => handleLocationFilterClick('filter-lo-rhoon')}
            >
              Rotterdam/Rhoon
            </span>
            <span
              className={`location-filter ${activeLocationFilter === 'filter-lo-groningen' ? 'location-active-filter' : ''}`}
              onClick={() => handleLocationFilterClick('filter-lo-groningen')}
            >
              Groningen
            </span>
            <span
              className={`location-filter ${activeLocationFilter === 'filter-lo-neermoor' ? 'location-active-filter' : ''}`}
              onClick={() => handleLocationFilterClick('filter-lo-neermoor')}
            >
              Neermoor
            </span>
            <span
              className={`location-filter ${activeLocationFilter === 'filter-lo-amsterdam' ? 'location-active-filter' : ''}`}
              onClick={() => handleLocationFilterClick('filter-lo-amsterdam')}
            >
              Amsterdam
            </span>
            <span
              className={`location-filter ${activeLocationFilter === 'filter-lo-antwerpen' ? 'location-active-filter' : ''}`}
              onClick={() => handleLocationFilterClick('filter-lo-antwerpen')}
            >
              Antwerpen
            </span>
            <span
              className={`location-filter ${activeLocationFilter === 'filter-lo-ghent' ? 'location-active-filter' : ''}`}
              onClick={() => handleLocationFilterClick('filter-lo-ghent')}
            >
              Ghent
            </span>
          </div>

          <span className="inner-divider"></span>

          <div className="filters-department">
            <strong style={{ color: "#169555" }}>Type</strong>
            <span
              className={`department-filter ${activeDepartmentFilter === 'filter-dp-all' ? 'department-active-filter' : ''}`}
              onClick={() => handleDepartmentFilterClick('filter-dp-all')}
            >
              All
            </span>
            <span
              className={`department-filter ${activeDepartmentFilter === 'filter-dp-fulltime' ? 'department-active-filter' : ''}`}
              onClick={() => handleDepartmentFilterClick('filter-dp-fulltime')}
            >
              Fulltime
            </span>

            <span
              className={`department-filter ${activeDepartmentFilter === 'filter-dp-parttime' ? 'department-active-filter' : ''}`}
              onClick={() => handleDepartmentFilterClick('filter-dp-parttime')}
            >
              Partime
            </span>
            <span
              className={`department-filter ${activeDepartmentFilter === 'filter-dp-internship' ? 'department-active-filter' : ''}`}
              onClick={() => handleDepartmentFilterClick('filter-dp-internship')}
            >
              Internship
            </span>
          </div>
        </div>
      </div>


      <div className='vacancies-list'>

        {filteredData.length > 0 ? filteredData.slice(0, vacancyCount).map((item, index) => (

          <a class="vacancy-box" target="_parent">
            <a class="image-link" href={item.link}><img class="vacancy-img" src={item.yoast_head_json.og_image[0].url} alt="vacancy-image" /></a>
            <div class="vacancy-inner">
              <span class="vacancy-category">#VACANCY</span>
              <h3 class="vacancy-title" dangerouslySetInnerHTML={{ __html: item.title.rendered }}></h3>
              <p class="sub-info"><i class="fa-solid fa-location-pin"></i> <span class="vacancy-location">{item?.acf?.location}</span> <span class="green-seperator">|</span> <i class="fa-solid fa-euro-sign"></i> <span class="vacancy-salary">{item?.acf?.salary}</span> <span class="green-seperator">|</span> <i class="fa-solid fa-calendar-days"></i> <span class="vacancy-vacation">{item?.acf?.vacation}</span> <span>days</span> <span class="green-seperator">|</span> <i class="fa-solid fa-clock"></i> <span class="vacancy-hours">{item?.acf?.hours}</span> <span>hours</span></p>
              <a class="vacancy-button" href={item.link} target="_parent">VIEW VACANCY</a>
            </div>
          </a>

        )) : (<div class="no-news-found">
          <h3 style={{ fontWeight: 'bold' }}>No vacancies were found matching this criteria.</h3>
          <br />
          <p>Please clear your search.</p>
        </div>)}

      </div>
      <div className='button-div'>
        {filteredData.length > vacancyCount ? (<button onClick={handleLoadMore} class="load-more-btn"><span>LOAD MORE</span>
          <i class="fa fa-chevron-right"></i>
        </button>) : null}
      </div>
    </div>
  );
}

export default App;
